import { render } from "./ui-date-time.vue?vue&type=template&id=f61e2aea&ts=true"
import script from "./ui-date-time.vue?vue&type=script&lang=ts"
export * from "./ui-date-time.vue?vue&type=script&lang=ts"

import "./ui-date-time.vue?vue&type=style&index=0&id=f61e2aea&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__